import { useTranslation } from 'next-i18next';
import React, { FC } from 'react';
import Icon from 'src/common/components/Icon';
import UniversalLink from 'src/common/components/UniversalLink';
import { PATHS, PAGE_PARAM } from 'src/common/constants';

import styles from './ReturnLink.module.scss';

export type ReturnLinkProps = {
  location: string;
  locationTitle: string;
};

const ReturnLink: FC<ReturnLinkProps> = ({ location, locationTitle }) => {
  const [t] = useTranslation('search-page');
  let href = PATHS.SEARCH;
  if (location) {
    href = PATHS.SEARCH + location;
  }
  return (
    <UniversalLink
      href={`${href}${PAGE_PARAM}`}
      className={styles.root}
    >
      <Icon
        id="common/next-arrow"
        className={styles.icon}
      />
      {t(location ? 'return-link--location' : 'return-link--near-me', { location: locationTitle })}
    </UniversalLink>
  );
};

export default ReturnLink;
